import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../types';
import { useCallback, useEffect } from 'react';
import { HeatmapsRequestActions } from '../actions';

export const useFetchAllHeatmaps = (orgId: string, includeArchived: boolean) => {
  const dispatch = useDispatch<AppDispatch>();

  const fetchHeatmaps = useCallback(() => {
    dispatch(HeatmapsRequestActions.getAllHeatmaps({ orgId, includeArchived }));
  }, [dispatch, orgId, includeArchived]);

  useEffect(() => fetchHeatmaps(), [fetchHeatmaps]);
  return fetchHeatmaps;
};
